'use strict';

var Bacon, Dispatcher, PlatformUtils, R, T, addItemCommand, addItemStream, cartItemsErrors, cartSettingsStore, cartStore, cartStreamData, cloackAction, d, deleteItemAction, deleteItemByIdAction, deleteItemStream, existingCartItems, itemToDeleteFromId, itemsStream, itemsTotal, itemsURL, loadingStream, newItemStream, notNil, reloadCartItems, reloadCartItemsAction, reloadStreamsOnOrderChange, resUtil, updateItemAction, updateItemCommand, updateItemStream, visibleItems;

Bacon = require('baconjs');

R = require('ramda');

T = require('../../utils/translation');

Dispatcher = require('../../utils/dispatcher');

d = new Dispatcher('CART::ITEMS');

resUtil = require('../../utils/resources');

PlatformUtils = require('../../utils/platform');

cartStore = require('./index');

cartSettingsStore = require('./settings');

cartStreamData = cartStore.cart;

notNil = R.pipe(R.isNil, R.not);

// ************ ITEMS ***************
itemsURL = cartStreamData.filter(notNil).map(R.path(['items', 'resource_url'])).filter(notNil).skipDuplicates().toEventStream();

// In order to avoid triggering events when changing
// carts as we have one cart active per app
addItemStream = new Bacon.Bus(); // gets the ordering item

addItemCommand = new Bacon.Bus(); // gets the url + ordering item

cloackAction = new Bacon.Bus();

newItemStream = addItemCommand.flatMap(resUtil.createResource).map(R.prop('item')).map(R.of).flatMap(T.translateCartItems).map(R.nth(0)); // actual add output

updateItemAction = new Bacon.Bus();

updateItemStream = updateItemAction.debounce(500).map(function (_ref) {
  var item = _ref.item,
      quantity = _ref.quantity,
      comments = _ref.comments;

  return {
    url: item.resource_url,
    item: {
      quantity: quantity || item.quantity,
      comments: comments || item.comments
    }
  };
}).flatMapLatest(resUtil.updateResource).map(R.prop('item'));

deleteItemAction = new Bacon.Bus();

deleteItemStream = deleteItemAction.map(function (item) {
  return {
    url: item.resource_url
  };
}).flatMap(resUtil.deleteResource);

existingCartItems = itemsURL.flatMapLatest(resUtil.loadResourceFromURL).map(R.prop('items')).flatMap(T.translateCartItems);

reloadCartItemsAction = new Bacon.Bus();

reloadCartItems = itemsURL.sampledBy(reloadCartItemsAction).flatMapLatest(resUtil.loadResourceFromURL).map(R.prop('items')).flatMap(T.translateCartItems);

cartItemsErrors = cartStreamData.map(R.prop('items')).map(R.pickAll(['errors', 'info']));

cartStore.reloadTotals.plug(Bacon.mergeAll(newItemStream, updateItemStream, deleteItemStream));

reloadStreamsOnOrderChange = function reloadStreamsOnOrderChange() {
  var o, s, t;
  o = cartSettingsStore.orderType;
  t = cartSettingsStore.orderTime;
  s = Bacon.mergeAll(deleteItemStream, o.selected, t.value, t.selected).skipDuplicates().debounce(600);
  return reloadCartItemsAction.plug(s);
};

updateItemCommand = d.stream('update-item-command').flatMap(resUtil.updateResource).map(R.prop('item'));

itemsStream = Bacon.update({
  url: null,
  items: [],
  hide: []
  // Set resource url
}, [itemsURL], function (_, url) {
  return {
    items: [],
    url: url,
    hide: []
  };
  // Load existing items
}, [existingCartItems], function (_ref2, items) {
  var url = _ref2.url,
      hide = _ref2.hide,
      _ = _ref2._;

  return { url: url, items: items, hide: hide };
}, [reloadCartItems], function (_ref3, items) {
  var url = _ref3.url,
      _ = _ref3._,
      hide = _ref3.hide;

  return { url: url, items: items, hide: hide };
}, [addItemStream], function (_ref4, item) {
  var url = _ref4.url,
      items = _ref4.items,
      hide = _ref4.hide;

  addItemCommand.push({ url: url, item: item });
  return { url: url, items: items, hide: hide };
}, [newItemStream], function (_ref5, item) {
  var url = _ref5.url,
      items = _ref5.items,
      hide = _ref5.hide;

  return {
    url: url,
    hide: hide,
    items: R.append(item, items)
  };
}, [updateItemAction], function (_ref6, _ref7) {
  var url = _ref6.url,
      items = _ref6.items,
      hide = _ref6.hide;
  var item = _ref7.item,
      quantity = _ref7.quantity,
      comments = _ref7.comments;

  var index, newItem;
  index = R.findIndex(R.propEq('id', item.id), items);
  if (index >= 0) {
    newItem = items[index];
    if (quantity) {
      newItem = R.assoc('quantity', quantity, newItem);
    }
    if (comments) {
      newItem = R.assoc('comments', comments, newItem);
    }
    return {
      url: url,
      hide: hide,
      items: R.update(index, newItem, items)
    };
  } else {
    return { url: url, hide: hide, items: items };
  }
  // add item result
}, [updateItemStream], function (_ref8, item) {
  var url = _ref8.url,
      items = _ref8.items,
      hide = _ref8.hide;

  var index;
  index = R.findIndex(R.propEq('id', item.id), items);
  return {
    url: url,
    hide: hide,
    items: R.update(index, item, items)
  };
  // delete
}, [deleteItemAction, deleteItemStream], function (_ref9, item, result) {
  var url = _ref9.url,
      items = _ref9.items,
      hide = _ref9.hide;

  if (result.success) {
    return {
      url: url,
      items: R.reject(R.propEq('id', item.id), items),
      hide: R.reject(R.equals(item.id), hide)
    };
  } else {
    return {
      url: url,
      items: items,
      hide: hide
    };
  }
}, [cloackAction], function (_ref10, _ref11) {
  var url = _ref10.url,
      items = _ref10.items,
      hide = _ref10.hide;
  var id = _ref11.id,
      visible = _ref11.visible;

  if (visible) {
    return {
      url: url,
      items: items,
      hide: R.reject(R.equals(id), hide)
    };
  } else {
    return {
      url: url,
      items: items,
      hide: R.append(id, hide)
    };
  }
}, [d.stream('update-item')], function (_ref12, _ref13) {
  var url = _ref12.url,
      items = _ref12.items,
      hide = _ref12.hide;
  var id = _ref13.id,
      item = _ref13.item;

  var index, itemUrl;
  index = R.findIndex(R.propEq('id', id), items);
  itemUrl = R.prop('resource_url', R.nth(index, items));
  d.stream('update-item-command').push({
    url: itemUrl,
    item: item
  });
  return {
    url: url,
    items: R.reject(R.propEq('id', id), items),
    hide: hide
  };
}, [updateItemCommand], function (_ref14, item) {
  var url = _ref14.url,
      items = _ref14.items,
      hide = _ref14.hide;

  return {
    url: url,
    hide: hide,
    items: R.append(item, items)
  };
});

visibleItems = itemsStream.map(function (_ref15) {
  var items = _ref15.items,
      hide = _ref15.hide;

  return R.filter(R.pipe(R.prop('id'), R.flip(R.contains)(hide), R.not), items);
});

deleteItemByIdAction = new Bacon.Bus();

itemToDeleteFromId = deleteItemByIdAction.flatMap(function (id) {
  return itemsStream.map(R.prop('items')).map(R.find(R.propEq('id', id))).take(1);
}).flatMap(function (res) {
  if (!res) {
    return new Bacon.Error("Cannot find requested item to remove");
  } else {
    return new Bacon.Next(res);
  }
});

deleteItemAction.plug(itemToDeleteFromId);

itemsTotal = visibleItems.map(R.prop('items')).map(R.map(R.props(['price', 'quantity']))).map(R.map(R.reduce(R.multiply, 1))).map(R.sum);

// ************* loading
loadingStream = Bacon.mergeAll(addItemStream.awaiting(newItemStream.mapError(R.identity)), updateItemAction.awaiting(itemsStream.mapError(R.identity)), deleteItemAction.awaiting(itemsStream.mapError(R.identity)));

cartStore.addLoading(loadingStream);

loadingStream.onValue(PlatformUtils.showLoadingIndicator);

module.exports = {
  active: visibleItems.map(R.pipe(R.length, R.lt(0))),
  items: visibleItems,
  add: function add(orderItem) {
    addItemStream.push(orderItem);
    return newItemStream;
  },
  remove: function remove(item) {
    deleteItemAction.push(item);
    return deleteItemStream;
  },
  removeById: function removeById(item_id) {
    deleteItemByIdAction.push(item_id);
    return deleteItemStream;
  },
  updateItem: function updateItem(id, item) {
    setTimeout(function () {
      return d.stream('update-item').push({
        id: parseInt(id),
        item: item
      });
    }, 0);
    return updateItemCommand;
  },
  updateQuantity: function updateQuantity(item, quantity) {
    return updateItemAction.push({ item: item, quantity: quantity });
  },
  updateComment: function updateComment(item, comments) {
    return updateItemAction.push({ item: item, comments: comments });
  },
  errors: cartItemsErrors,
  total: itemsTotal,
  loading: loadingStream,
  reloadItemsOnOrderChange: reloadStreamsOnOrderChange,
  reload: function reload() {
    return reloadCartItemsAction.push(new Date());
  },
  setItemVisibility: function setItemVisibility(id, visible) {
    return cloackAction.push({ id: id, visible: visible });
  }
};